import { registerModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import BIRDPackage from './BIRDPackage';
import '@sas-dvr/ltjs-gtl/lib';
registerModule('BIRD', [BIRDPackage]);
